"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
const theme_1 = require("../../components/theme");
const theme_palette_1 = require("../../components/theme.palette");
exports.CSS = {
    container: 'c-TagIcon',
    redDot: 'c-TagIcon__RedDot',
};
exports.Style = {
    [exports.CSS.container]: {
        width: 'inherit',
        height: 'inherit',
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        'box-sizing': 'border-box',
        fontFamily: theme_1.DefaultTheme.font.familyCondensed,
        fontWeight: theme_1.DefaultTheme.font.weight.bold,
        boxShadow: theme_1.DefaultTheme.shadow.box.dp2,
        color: theme_1.DefaultTheme.font.color.primary,
        border: '2px solid',
        position: 'relative',
    },
    [exports.CSS.redDot]: {
        position: 'absolute',
        top: '-2px',
        right: '-2px',
        width: '8px',
        height: '8px',
        'border-radius': '50%',
        'background-color': theme_palette_1.ColorPalette2022Branding.lightRed,
        border: '1px solid #FFFFFF',
        'box-shadow': theme_1.DefaultTheme.shadow.box.dp2,
        'pointer-events': 'none',
    },
};
//# sourceMappingURL=tag.icon.style.js.map